<template>
	<div class="pochan-wrap">
		<div class="chart-title">破产企业职工权益</div>
		<div class="chart-title">兑付情况</div>
		<!-- 两个统计卡片 -->
		<div class="pochan-cards" @click="openEnterprisePopup">
			<div class="pochan-card">
				<div class="card-label">兑付总家数</div>
				<div class="card-value">{{ enterpriseCount }}<span class="card-unit">家</span></div>
			</div>
			<div class="pochan-card pochan-card--amount">
				<div class="card-label">兑付总金额</div>
				<div class="card-value">{{ totalAmount }}</div>
				<div class="card-sub">元</div>
			</div>
		</div>

		<!-- 一级弹窗：企业列表 -->
		<div
			class="pochan-popup dashboard-chart-popup dashboard-chart-popup--wide"
			v-if="popupVisible && popupView === 'list'"
			v-append-to-body
		>
			<div class="popup-head">
				<div class="popup-dot"></div>
				<span class="popup-head-text">破产企业职工权益兑付情况明细（共 {{ enterpriseCount }} 家）</span>
				<el-button @click="closePopup" type="text" icon="el-icon-circle-close" />
			</div>
			<el-table
				:data="enterpriseList"
				stripe
				:border="false"
				style="width:100%;background-color:#071a52;"
				height="260"
				@row-click="openEnterpriseDetail"
			>
				<el-table-column type="index" width="45" label="序号" align="center" />
				<el-table-column prop="receiveEnterprise" label="收款企业" show-overflow-tooltip />
				<el-table-column prop="payCount" label="付款次数" width="90" align="center" />
				<el-table-column label="操作" width="70" align="center">
					<template slot-scope="scope">
						<span class="link-detail" @click.stop="openEnterpriseDetail(scope.row)">详情</span>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 二级弹窗：某企业付款明细 -->
		<div
			class="pochan-popup dashboard-chart-popup dashboard-chart-popup--wide"
			v-if="popupVisible && popupView === 'detail'"
			v-append-to-body
		>
			<div class="popup-head">
				<div class="popup-dot"></div>
				<span class="popup-head-text popup-head-text--detail">{{ selectedEnterprise.receiveEnterprise }} - 付款明细</span>
				<el-button @click="backToEnterpriseList" type="text" class="popup-back-btn">返回</el-button>
				<el-button @click="closePopup" type="text" icon="el-icon-circle-close" />
			</div>
			<el-table
				:data="selectedPayments"
				stripe
				:border="false"
				style="width:100%;background-color:#071a52;"
				height="260"
			>
				<el-table-column type="index" width="45" label="序号" align="center" />
				<el-table-column prop="payTime" label="付款时间" width="110" align="center" />
				<el-table-column prop="payAmount" label="付款金额(元)" align="center" />
			</el-table>
		</div>
	</div>
</template>

<script>
	import apis from '@/http/apis';

	export default {
		name: 'PochanQiyeDuifu',
		data() {
			return {
				popupVisible: false,
				popupView: 'list',
				enterpriseCount: 0,
				totalAmount: '0.00',
				enterpriseList: [],
				detailList: [],
				selectedEnterprise: {},
				selectedPayments: [],
			};
		},
		created() {
			this.fetchData();
		},
		methods: {
			formatAmount(val) {
				const num = Number(val);
				if (!Number.isFinite(num)) return '0.00';
				return num.toLocaleString('zh-CN', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				});
			},

			mapEnterpriseList(list) {
				return (list || []).map(item => ({
					guid: item.guid,
					payEnterprise: item.payEnterprise || '',
					receiveEnterprise: item.receiveEnterprise || '',
					payCount: item.payCount || 0,
					totalAmount: item.totalAmount,
				}));
			},

			getPaymentsByGuid(guid) {
				return (this.detailList || [])
					.filter(item => item.parentGuid === guid)
					.map(item => ({
						payTime: item.payTime || '',
						payAmount: this.formatAmount(item.payAmount),
					}));
			},

			fetchData() {
				apis.bankruptEmpRightsPay()
					.then((res) => {
						const payload = res && res.data ? res.data : {};
						const summary = payload.summary || {};
						this.enterpriseCount = summary.enterpriseCount || 0;
						this.totalAmount = this.formatAmount(summary.totalAmount);
						this.enterpriseList = this.mapEnterpriseList(payload.enterpriseList);
						this.detailList = payload.detailList || [];
					})
					.catch((err) => {
						console.error('破产企业职工权益兑付接口请求失败', err);
						this.enterpriseCount = 0;
						this.totalAmount = '0.00';
						this.enterpriseList = [];
						this.detailList = [];
					});
			},

			openEnterprisePopup() {
				this.popupView = 'list';
				this.selectedEnterprise = {};
				this.selectedPayments = [];
				this.popupVisible = true;
			},

			openEnterpriseDetail(row) {
				if (!row || !row.guid) return;
				this.selectedEnterprise = row;
				this.selectedPayments = this.getPaymentsByGuid(row.guid);
				this.popupView = 'detail';
			},

			backToEnterpriseList() {
				this.popupView = 'list';
				this.selectedEnterprise = {};
				this.selectedPayments = [];
			},

			closePopup() {
				this.popupVisible = false;
				this.popupView = 'list';
				this.selectedEnterprise = {};
				this.selectedPayments = [];
			},
		},
	};
</script>

<style scoped>
	.pochan-wrap {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		overflow: visible;
	}

	.chart-title {
		font-size: 12px;
		color: #fcf883;
		text-align: center;
		padding: 3px 0 0;
		letter-spacing: 1px;
		flex-shrink: 0;
	}

	.pochan-cards {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 8px;
		padding: 8px 10px;
		box-sizing: border-box;
		cursor: pointer;
	}

	.pochan-card {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background: rgba(0, 118, 255, 0.12);
		border: 1px solid rgba(0, 200, 255, 0.35);
		border-radius: 8px;
		padding: 6px 0;
		transition: background 0.2s;
	}

	.pochan-card:hover {
		background: rgba(0, 118, 255, 0.22);
	}

	.pochan-card--amount {
		border-color: rgba(12, 237, 143, 0.45);
		background: rgba(15, 179, 110, 0.10);
	}

	.pochan-card--amount:hover {
		background: rgba(15, 179, 110, 0.20);
	}

	.card-label {
		font-size: 11px;
		color: rgba(1, 228, 255, 0.8);
		letter-spacing: 0.5px;
		margin-bottom: 4px;
	}

	.pochan-card--amount .card-label {
		color: rgba(15, 179, 110, 0.9);
	}

	.card-value {
		font-size: 14px;
		font-weight: bold;
		color: #01e4ff;
		line-height: 1.1;
	}

	.pochan-card--amount .card-value {
		color: #0fb36e;
	}

	.card-unit {
		font-size: 12px;
		font-weight: normal;
		margin-left: 2px;
		color: rgba(1, 228, 255, 0.7);
	}

	.card-sub {
		font-size: 10px;
		color: rgba(255, 255, 255, 0.45);
		margin-top: 3px;
	}

	.popup-head {
		margin: 10px;
		color: #ffffff;
		font-size: 14px;
		font-weight: 600;
		display: flex;
		align-items: center;
		gap: 5px;
		position: relative;
		padding-right: 56px;
	}

	.popup-dot {
		width: 14px;
		height: 14px;
		border-radius: 50%;
		background-color: #fcf883;
		flex-shrink: 0;
	}

	.popup-head-text {
		flex: 1;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.popup-head-text--detail {
		padding-right: 40px;
	}

	.popup-back-btn {
		position: absolute;
		right: 28px;
		top: 50%;
		transform: translateY(-50%);
		color: #01e4ff !important;
		font-size: 12px;
		padding: 0;
	}

	.link-detail {
		color: #01e4ff;
		cursor: pointer;
		font-size: 12px;
	}

	.link-detail:hover {
		color: #fcf883;
	}

	.pochan-popup ::v-deep .el-table__body tr {
		cursor: pointer;
	}

	.pochan-popup ::v-deep .el-icon-circle-close {
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		font-size: 20px;
		color: #fff;
	}

	.pochan-popup ::v-deep .el-table tr {
		color: #fff !important;
		background-color: #071a52 !important;
	}

	.pochan-popup ::v-deep .el-table th.el-table__cell {
		color: #fff !important;
		background-color: #3c4a77 !important;
	}

	.pochan-popup ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
		background-color: #0d2569 !important;
	}

	.pochan-popup ::v-deep .el-table__cell {
		padding: 5px 0 !important;
		font-size: 12px;
		border-right: 1px solid rgba(255, 255, 255, 0.1) !important;
		border-bottom: none !important;
	}

	.pochan-popup ::v-deep .el-table::before {
		height: 0;
	}
</style>
